export default __webpack_public_path__ + "static/media/el-shape-v2.23902fc1.png";